<div class="dialog">
    <div class="dialog-title">
        <div class="dialog-back-button" (click)="closeDialog()"></div>
        <div class="dialog-title-text">{{title}}</div>
    </div>
    <div class="dialog-body" [innerHTML]="content"></div>
</div>